module.exports = __webpack_public_path__ + "img/others.c3b0dcc1.png";